export default __webpack_public_path__ + "static/media/cross-button.952074de.svg";